import React from 'react'
import { Link } from 'react-router-dom'

interface CustomLinkProps {
  to: string;
  children: string;
  propsClass: string;
  propsStyle: any;
}

const CustomLink = (props: CustomLinkProps) => {
  const { to, children, propsClass, propsStyle } = props

  return (
    <Link
      className={'link' + (propsClass || '')}
      style={{ textDecoration: 'none', ...(propsStyle || {}) }}
      to={to}
    >
      {children}
    </Link>
  )
}
export default CustomLink

